import * as React from "react";
import { HeadingTypeTwo, MobileTooltip, Icon } from "sb-resp-ui";

export class Heading extends React.Component<{
    label: string
    isDesktop?: boolean
    tooltipMessage?: string
}, {}> {

    render() {
        const tooltipActive = this.props.tooltipMessage ? "rj-heading-2--tooltip-active" : "";
        return (
            <HeadingTypeTwo modifier={`my-pulse-bets ${tooltipActive}`}>
                {!this.props.isDesktop && this.props.tooltipMessage && <MobileTooltip message={this.props.tooltipMessage} />}
                <span className="rj-heading-2__text-container">
                    <span className="rj-heading-2__text">{this.props.label}</span>
                </span>

                <span className="rj-heading-2__right-container">
                    <Icon i="i-o-pulsebet-pulse" />
                </span>
            </HeadingTypeTwo>
        )
    }
}